import {
    getOutlookInstance,
    initializeOutlookInstance,
    OutlookInstance,
} from '@outlook/hxcore_web';
import { initializeHx } from 'hx-init';

// lazily initialize hx on first usage
var hxInstance: OutlookInstance | undefined = undefined;
export function getHxInstance(): OutlookInstance {
    if (hxInstance === undefined) {
        const bridge = {
            getInitialObjects: () => window.HxGlobals?.initialObjects,
            postMessageToNative: (message: any) => {
                window.chrome?.webview?.postMessage(message);
            },
            setProcessMessageFromNativeEventHandler: (eventHandler: (event: any) => void) => {
                window.chrome?.webview?.addEventListener('message', (event: any) => {
                    eventHandler(event.data);
                });
            },
        };
        initializeOutlookInstance(bridge);

        hxInstance = getOutlookInstance();
        initializeHx(hxInstance);
    }

    return hxInstance;
}
